import { render } from "./tablePagination.vue?vue&type=template&id=cc841f02"
import script from "./tablePagination.vue?vue&type=script&lang=js"
export * from "./tablePagination.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__